import * as React from "react"

export const HorizontalDivider = () => {
  return <div className="w-full bg-gray-200 h-px"></div>
}
